"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.PapertrailContent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("../../../../components/Grid"));

var _ActivationContent = require("./ActivationContent");

var PapertrailVisibility = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-visibility-28da4f68750475521c1a333451c9a87e.svg";
var PapertrailTroubleshoot = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-troubleshoot-5da3a7e5764942004eb9fa0c0cd6fe5b.svg";
var PapertrailAnalysis = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-analysis-ab8da01532671120d9ae05f6837eee8f.svg";
var PapertrailLogo = "https://cdn.solarwinds.cloud/cloud-ui/assets/papertrail-logo-21679171eb7eebab71b4e99a23e98565.svg";

var PapertrailContent = function PapertrailContent(_ref) {
  var productStatus = _ref.productStatus;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductLogo, {
    logo: PapertrailLogo
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductDescription, {
    title: "Aggregate all your logs, your own way.",
    content: "Thousands of companies trust Papertrail to manage billions of log messages every day. Consolidate your logs in one place with cloud-hosted log management service that typically takes only minutes to set up."
  }), /*#__PURE__*/_react["default"].createElement(_Grid["default"].Row, null, /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: PapertrailVisibility,
    title: "Instant Visibility",
    content: "Consolidate syslog, text log files, Apache, Windows events, cloud hosting, MySQL, and more."
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: PapertrailTroubleshoot,
    title: "Troubleshoot Faster",
    content: "Search large volumes of streaming or stored log messages in a flash with our lightning search cabability."
  }), /*#__PURE__*/_react["default"].createElement(_ActivationContent.ProductSection, {
    image: PapertrailAnalysis,
    title: "In-depth Analysis",
    content: "With log velocity analytics, visualize log throughput to quickly identify patterns and anomalies."
  })), /*#__PURE__*/_react["default"].createElement(_ActivationContent.Subscription, {
    productStatus: productStatus,
    type: _ActivationContent.SUBSCRIPTION_TYPE.FREE
  }));
};

exports.PapertrailContent = PapertrailContent;